import React, { useState } from 'react'
import OrgTree from '../components/OrgTree'
import OrgDetail from '../components/OrgDetail'
import OrgCreate from '../components/OrgCreate'

export default function OrgsPage() {
    const [orgQ, setOrgQ] = useState('')
    const [selected, setSelected] = useState(null)
    const [refreshKey, setRefreshKey] = useState(0)

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1)
    }
    return (
        <section>
            <h1 className="text-2xl font-bold">조직 관리</h1>
            <p className="text-slate-600 mt-2">지연 로딩, 페이징, 조직 이동 지원</p>
            
            <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* 조직 트리 */}
                <div className="rounded border p-4">
                    <h2 className="font-semibold mb-3">조직 트리</h2>
                    <div className="mb-3">
                        <input 
                            className="w-full rounded border px-3 py-2 text-sm" 
                            placeholder="검색: 조직명" 
                            value={orgQ} 
                            onChange={(e) => setOrgQ(e.target.value)} 
                        />
                    </div>
                    <OrgTree 
                        key={`tree-${refreshKey}`}
                        onSelect={setSelected}
                        selectedId={selected?.id}
                        searchQuery={orgQ}
                    />
                </div>

                {/* 조직 상세 및 관리 */}
                <div className="lg:col-span-2 space-y-6">
                    {/* 조직 상세 */}
                    <div className="rounded border p-4">
                        <h2 className="font-semibold mb-3">조직 상세</h2>
                        <OrgDetail 
                            selectedOrg={selected}
                            onUpdate={handleRefresh}
                            onDelete={() => {
                                setSelected(null)
                                handleRefresh()
                            }}
                        />
                    </div>

                    {/* 조직 생성: 선택된 조직 하위 생성도 항상 가능하도록 노출 */}
                    <div className="rounded border p-4">
                        <h2 className="font-semibold mb-3">{selected ? '하위 조직 생성' : '새 조직 생성'}</h2>
                        <OrgCreate
                            key={`create-${selected?.id || 'root'}-${refreshKey}`}
                            onCreate={handleRefresh}
                            defaultParentOrgId={selected?.id || null}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}


